const init = () => {
    globalClicks();
    backToTop();
    pdpReviewsScrollFix();
    industriesServedDropdown();
    // featuredBlog();
};
const storefrontAccessToken = '48a66cb77f09365e714462474426676d';
const getArticles = async () => {
    const query = `
        query GetArticles($first: Int!, $after: String) {
            articles(first: $first, after: $after) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        handle
                        title
                        tags
                        image {
                            url(transform: {preferredContentType: PNG})
                        }
                        excerpt
                        publishedAt
                        blog {
                            title
                            handle
                        }
                    }
                }
            }
        }
    `;
    let allArticles = [];
    let hasNextPage = true;
    let cursor = null;
    while (hasNextPage) {
        const response = await fetch(`https://${Shopify.shop}/api/2025-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken
            },
            body: JSON.stringify({ query, variables: {
                first: 250,
                after: cursor
            } }),
        });
        const result = await response.json();
        const edges = result.data?.articles?.edges?.map(edge => edge.node);
        const publishedArticles = edges?.filter(edge => !!edge.publishedAt);
        allArticles.push(...publishedArticles);
        hasNextPage = result.data?.articles?.pageInfo?.hasNextPage;
        cursor = result.data?.articles?.pageInfo?.endCursor;
    }
    return allArticles;
};

const createArticleSlide = (article, groupHandle, sectionId, index) => {
    return `
        <div class="blog__post grid__item article slider__slide" data-cascade id="Slide-${groupHandle}-template--${sectionId}-${index}">
            <div class="article-card-wrapper card-wrapper">
                <div class="card article-card card--card card--media">
                    <div class="card__inner ratio">
                        ${
                            article.image ?
                                `
                        <div class="article-card__image-wrapper card__media">
                            <div class="article-card__image media">
                                <img src="${article.image.url}" alt="${article.image.altText || article.title}" />
                            </div>
                        </div>
                        `
                            :   ''
                        }
                    </div>
                    <h3 class="card__heading h2">
                        <a href="${article.url}" class="full-unstyled-link">${article.title}</a>
                    </h3>
                    <div class="excerpt-content">
                        <p class="article-card__excerpt rte-width">${article.excerpt || ''}</p>
                    </div>
                    <a href="${article.url}" class="view-article button button--secondary shop-now">
                        Learn More
                    </a>
                </div>
            </div>
        </div>


        <div class="blog__post grid__item article slider__slide"  data-cascade >
                                  
<div class="article-card-wrapper card-wrapper underline-links-hover ">
    
    <div class="
        card article-card
        card--card
        
         card--media
         color-scheme-2 gradient
        
    ">
        <div class="card__inner  ratio"><div class="article-card__image-wrapper card__media">
                <div class="article-card__image media media--hover-effect" >
                    
<img srcset="//www.fibreglast.com/cdn/shop/articles/gel-coat-application-guide_520x500_520x500_eaac3cfb-fd2d-4682-8bb7-0c871028cd54.png?v=1741116145&width=165 165w,//www.fibreglast.com/cdn/shop/articles/gel-coat-application-guide_520x500_520x500_eaac3cfb-fd2d-4682-8bb7-0c871028cd54.png?v=1741116145&width=360 360w,//www.fibreglast.com/cdn/shop/articles/gel-coat-application-guide_520x500_520x500_eaac3cfb-fd2d-4682-8bb7-0c871028cd54.png?v=1741116145 500w
                    " src="//www.fibreglast.com/cdn/shop/articles/gel-coat-application-guide_520x500_520x500_eaac3cfb-fd2d-4682-8bb7-0c871028cd54.png?v=1741116145&width=533" sizes="(min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" alt="Gel Coat Application Guide" class="motion-reduce"  loading="lazy"  width="500" height="500">
                </div>
            </div><div class="card__content">
                <div class="card__information">
                    <h3 class="card__heading h2">
                        <a href="/blogs/learning-center/gel-coat-application-guide" class="full-unstyled-link">
                            Gel Coat Application Guide
                        </a>
                    </h3>
                    <div class="article-card__info caption-with-letter-spacing h5">
                        
</div><p class="article-card__excerpt rte-width">Gel coat is the most common surface coating used in the fabrication and repair of fiberglass reinforced products. Gel Coat is a specially formulated two-part polyester resin that is designed to be the first layer of resin applied in a mold when making a polyester or vinyl ester composite part. It is intended to create an opaque surface which will completely block glass pattern show-through. Polyester resins in general, and specifically gel coats, are naturally UV resistant, and properly cured parts can be submerged in water. Most boats are made using gel coat with polyester resin and fiberglass.
</p><div class="article-card__footer"></div></div></div>
        </div>
        <h3 class="card__heading h2">
            <a href="/blogs/learning-center/gel-coat-application-guide" class="full-unstyled-link">
                Gel Coat Application Guide
            </a>
        </h3><div class="excerpt-content">
                    <p class="article-card__excerpt rte-width">Gel coat is the most common surface coating used in the fabrication and repair of fiberglass reinforced products. Gel Coat is a specially formulated two-part polyester resin that is designed...
</p></div><a href="/blogs/learning-center/gel-coat-application-guide" class="view-article button button--secondary shop-now">
            Learn More
        </a>
        
    </div>
</div>
                                </div>
    `;
};

const featuredBlog = async () => {
    const blogCenterHandles = document.querySelectorAll('.blog-center .collapsible-desktop-toggle');
    if (blogCenterHandles) {
        const allArticles = await getArticles();
        console.log(allArticles);
        document.querySelectorAll('.blog-by-type .slider__slide').forEach(el => el.remove());
        blogCenterHandles?.forEach(handle => {
            const typeHandle = handle.dataset?.handle;
            const articleType = typeHandle?.replace('-', ' ');
            const sectionId = handle.dataset.selector.split('-').pop();
            const articles = allArticles.filter(article => article?.blog?.handle == 'learning-center' && article?.tags?.some(tag => tag.toLowerCase() == articleType.toLowerCase()));
            const slider = document.getElementById(`Slider-${typeHandle}-template--${sectionId}`);
            console.log(`Slider-${typeHandle}-template--${sectionId}`);
            if (slider) {
                articles.forEach((article, idx) => {
                    slider.insertAdjacentHTML('beforeend', createArticleSlide(article, typeHandle, sectionId, idx + 1));
                });
            }
        });
        if (window.Flickity) {
            document.querySelectorAll('.blog-by-type').forEach(sliderEl => {
                if (sliderEl.flickityInstance) {
                    sliderEl.flickityInstance.destroy();
                }
                sliderEl.flickityInstance = new Flickity(sliderEl, {
                    cellAlign: 'left',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: true,
                });
            });
        }
    }
}
const globalClicks = () => {
    document.addEventListener('click', function (e) {
        const target = e.target;
        mobileFooter(target);
        readMore(target);
        collapsibleTabs(target, e); // Open one collapsible tab at a time (.one-rule)
    }, false);
};
const backToTop = () => {
    const goTopBtn = document.getElementById('BackToTop');
    if (goTopBtn) {
        window.addEventListener('scroll', () => {
            const scrolled = window.pageYOffset;
            const coords = 200;
            if (scrolled > coords) {
                goTopBtn.classList.add('shown');
            }
            if (scrolled < coords) {
                goTopBtn.classList.remove('shown');
            }
        });
        goTopBtn.addEventListener('click', (e) => {
            if (window.pageYOffset > 0) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    }
};
const pdpReviewsScrollFix = () => {
    setTimeout(() => {
        if (document.querySelector('.product .product__info-wrapper .jdgm-preview-badge--with-link') && document.getElementById('judgeme_product_reviews')) {
            document.querySelectorAll('.jdgm-preview-badge--with-link').forEach(element => {
                const newElement = element.cloneNode(true);
                element.parentNode.replaceChild(newElement, element);
              });
            const elements = document.querySelectorAll('.jdgm-preview-badge--with-link');
            elements.forEach(element => {
                element.addEventListener('click', function(e) {
                    e.preventDefault();
                    const reviewsElement = document.getElementById('judgeme_product_reviews');
                    const header = document.getElementsByClassName('header-wrapper')[0];
                    if (reviewsElement && header) {
                        const headerHeight = header.offsetHeight;
                        const elementPosition = reviewsElement.getBoundingClientRect().top + window.pageYOffset;
                        const offsetPosition = elementPosition - headerHeight;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }
      }, 1000);
};
const mobileFooter = (target) => {
    if (window.screen.width < 800) {
        if (target.classList.contains('footer-block__heading')) {
            const dropdownEl = target.closest('.footer-block-content');
            const isOpen = dropdownEl.classList.contains('open');
            if (isOpen) {
                dropdownEl.classList.remove('open');
            }
            else {
                dropdownEl.classList.add('open');
            }
        }
    }
};
const readMore = (target) => {
    if (target.classList.contains('read-more')) {
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};
const updateDesktopLinks = (id) => {
    const desktopToggles = document.querySelectorAll('.collapsible-desktop-toggle');
    if (desktopToggles.length) {
        desktopToggles.forEach(toggleEl => {
            if (toggleEl.classList.contains('is-open')) {
                toggleEl.classList.remove('is-open');
            }
        });
        const openedLink = document.querySelector(`[data-selector="${id}"]`);
        openedLink.classList.add('is-open');
    }
};
const collapsibleTabs = (target, e) => {
    if (window.screen.width >= 990) {
        if (target.classList.contains('collapsible-mobile-title') || target.tagName == 'SUMMARY') {
            const collapsibleContainer = target.closest('.collapsible-content-container');
            if (collapsibleContainer && collapsibleContainer.classList.contains('one-rule')) {
                e.preventDefault();
                const details = target.closest('details');
                const summary = details.querySelector('summary');

                collapsibleContainer.querySelectorAll('details').forEach((element) => {
                    if (element != details) {
                        element.removeAttribute("open");
                    }
                });
                collapsibleContainer.querySelectorAll('summary').forEach((element) => {
                    if (element.classList.contains('is-open') && element != summary) {
                        element.classList.remove('is-open');
                    }
                });
                updateDesktopLinks(summary.id);
                summary.classList.add('is-open');
                details.setAttribute('open', 'true');
            }
        }
        if (target.classList.contains('collapsible-desktop-title') || target.classList.contains('collapsible-desktop-toggle')) {
            e.preventDefault();
            let targetEl = target;
            if (target.classList.contains('collapsible-desktop-title')) {
                targetEl = targetEl.parentElement;
            }
            const selectorId = targetEl.dataset.selector;
            const blogTag = document.getElementById(selectorId);
            blogTag.click();
        }
    }
};
const industriesServedDropdown = () => {
    if (window.innerWidth >= 990) {
        const industriesDetails = document.getElementById('Details-HeaderMenu-industries-served');
        const industriesMenu = document.getElementById('HeaderMenu-industries-served');
        const menuContainer = document.querySelector('.header-middle-menu-container');
        
        if (industriesDetails && industriesMenu && menuContainer) {
            industriesMenu.addEventListener('mouseenter', function(e) {
                industriesDetails.setAttribute('open', '');
                document.body.classList.add('industries-dropdown-active');
            });
            
            industriesDetails.addEventListener('mouseleave', function(e) {
                setTimeout(() => {
                    industriesDetails.removeAttribute('open');
                    document.body.classList.remove('industries-dropdown-active');
                }, 100);
            });
            
            document.addEventListener('click', function(e) {
                if (!industriesDetails.contains(e.target) && 
                    document.body.classList.contains('industries-dropdown-active')) {
                    industriesDetails.removeAttribute('open');
                    document.body.classList.remove('industries-dropdown-active');
                }
            });
        }
    }
    
    window.addEventListener('resize', () => {
        if (window.innerWidth < 990) {
            const industriesDetails = document.getElementById('Details-HeaderMenu-industries-served');
            if (industriesDetails) {
                industriesDetails.removeAttribute('open');
                document.body.classList.remove('industries-dropdown-active');
            }
        }
    });
};
(function () {
    init();
})();